export default "__VITE_ASSET__ad5x4stk__"